import React, { useState } from 'react';
import { API_ENDPOINTS } from '../utils/apiConfig';

/**
 * Page de demande de réinitialisation de mot de passe
 */
const ForgotPassword = ({ onBackToLogin }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_ENDPOINTS.AUTH}/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.error || 'Erreur lors de l\'envoi');
      }
    } catch (err) {
      setError('Erreur de connexion au serveur');
    } finally {
      setLoading(false);
    }
  };

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    },
    card: {
      background: 'white',
      borderRadius: '12px',
      padding: '40px',
      width: '100%',
      maxWidth: '400px',
      boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
    },
    logo: {
      textAlign: 'center',
      marginBottom: '30px'
    },
    logoImg: {
      height: '50px'
    },
    title: {
      fontSize: '24px',
      fontWeight: '600',
      color: '#333',
      marginBottom: '10px',
      textAlign: 'center'
    },
    subtitle: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '30px',
      textAlign: 'center'
    },
    form: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    inputGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px'
    },
    label: {
      fontSize: '14px',
      fontWeight: '500',
      color: '#333'
    },
    input: {
      padding: '12px 16px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      fontSize: '14px',
      transition: 'border-color 0.2s',
      outline: 'none'
    },
    button: {
      padding: '14px',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      transition: 'transform 0.2s, box-shadow 0.2s'
    },
    buttonDisabled: {
      opacity: 0.7,
      cursor: 'not-allowed'
    },
    error: {
      background: '#fee',
      color: '#c00',
      padding: '12px',
      borderRadius: '8px',
      fontSize: '14px',
      textAlign: 'center'
    },
    success: {
      background: '#e8f5e9',
      color: '#2e7d32',
      padding: '20px',
      borderRadius: '8px',
      textAlign: 'center'
    },
    successIcon: {
      fontSize: '48px',
      marginBottom: '15px'
    },
    successTitle: {
      fontSize: '18px',
      fontWeight: '600',
      marginBottom: '10px'
    },
    successText: {
      fontSize: '14px',
      lineHeight: '1.5'
    },
    backLink: {
      textAlign: 'center',
      marginTop: '20px'
    },
    link: {
      color: '#667eea',
      textDecoration: 'none',
      fontSize: '14px',
      cursor: 'pointer'
    }
  };

  if (success) {
    return (
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.logo}>
            <img src="/logo_connect.png" alt="R-Connect" style={styles.logoImg} />
          </div>
          <div style={styles.success}>
            <div style={styles.successIcon}>📧</div>
            <div style={styles.successTitle}>Email envoyé !</div>
            <div style={styles.successText}>
              Si un compte existe avec cette adresse email, vous recevrez un lien de réinitialisation dans quelques instants.
              <br /><br />
              Pensez à vérifier vos spams.
            </div>
          </div>
          <div style={styles.backLink}>
            <span style={styles.link} onClick={onBackToLogin}>
              ← Retour à la connexion
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img src="/logo_connect.png" alt="R-Connect" style={styles.logoImg} />
        </div>

        <h1 style={styles.title}>Mot de passe oublié ?</h1>
        <p style={styles.subtitle}>
          Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.
        </p>

        <form onSubmit={handleSubmit} style={styles.form}>
          {error && <div style={styles.error}>{error}</div>}

          <div style={styles.inputGroup}>
            <label style={styles.label}>Adresse email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              required
              style={styles.input}
            />
          </div>

          <button
            type="submit"
            disabled={loading || !email}
            style={{
              ...styles.button,
              ...(loading || !email ? styles.buttonDisabled : {})
            }}
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le lien'}
          </button>
        </form>

        <div style={styles.backLink}>
          <span style={styles.link} onClick={onBackToLogin}>
            ← Retour à la connexion
          </span>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
